import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SpaceliftVcs } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Timestamp from "components/Timestamp";

const SpaceliftVcsReposTableCreatedAtCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<SpaceliftVcs>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={repo.createdAt} />
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableCreatedAtCell;
